import React from 'react';
import { observer, inject } from 'mobx-react';
import DeviceGroupForm from '../../components/DeviceGroup/DeviceGroupForm';
import styles from './DeviceGroup.less';
import { Table, Popconfirm, message } from 'antd';
import GroupModal from '../../components/DeviceGroup/GroupModal';

@inject('deviceGroupStore')
@observer
class DeviceGroup extends React.Component {
  constructor(props) {
    super(props);
    this.deleteGroup = this.deleteGroup.bind(this);
  }
  deleteGroup(groupName) {
    this.props.deviceGroupStore.deleteGroup(groupName).then(json => {
      if (!json) {
        message.success('删除分组成功');
      }
      this.props.deviceGroupStore.loadDeviceGroup();
    });
  }
  render() {
    const { deviceGroupArr, loadGroupList } = this.props.deviceGroupStore;
    const DeviceGroupColumns = [
      { title: '分组名称', dataIndex: 'tag_name', key: 'tag_name', width: 200 },
      { title: '设备数量', dataIndex: 'quantity', key: 'quantity', width: 100 },
      {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width: 200
      },
      { title: '分组描述', dataIndex: 'remark', key: 'remark', width: 300 },
      {
        title: '操作',
        key: 'action',
        width: 300,
        render: (text, record) => (
          <span>
            <a onClick={() => loadGroupList(record['tag_id'])}>查看分组</a>
            <Popconfirm
              title="确定要删除该分组"
              onConfirm={() => this.deleteGroup(record['tag_id'])}
              okText="确认"
              cancelText="取消"
            >
              <a className={styles.deleteGroup} href="#">
                删除分组
              </a>
            </Popconfirm>
          </span>
        )
      }
    ];
    return (
      <div className={styles.deviceGroupContainer}>
        <DeviceGroupForm />
        <div className={styles.tableContainer}>
          <Table
            pagination={{
              pageSize: 20
            }}
            columns={DeviceGroupColumns}
            dataSource={[...deviceGroupArr]}
          />
        </div>
        <GroupModal />
      </div>
    );
  }
}
export default DeviceGroup;



// WEBPACK FOOTER //
// ./src/pages/DeviceGroup/DeviceGroup.js